import React, {
  Fragment,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import WebSkyLayout from "./WebSkyLayout";
import { apiGet } from "../../../Utils/apiFetch";
import apiPath from "../../../Utils/apiPath";
import { isEmpty } from "lodash";
import jwt_decode from "jwt-decode";
import { usePolling } from "../../../component/usePolling";
import SingleEvent from "./SingleEvent";
import moment from "moment";
import { Link } from "react-router-dom";
const Inplay = () => {
  const isFirstRun = useRef(true);
  const [data, setData] = useState({});
  const [allOdds, setAllOdds] = useState([]);
  const [loader, setLoader] = useState(false);
  const [newResult, setNewResult] = useState([]);
  const tabs = [
    { key: "in_play", label: "In-Play" },
    { key: "today", label: "Today" },
    { key: "tomorrow", label: "Tomorrow" },
  ];
  const [activeTab, setActiveTab] = useState("in_play");
  const handleClick = (tab) => {
    setActiveTab(tab);
  };

  console.log(data, "data");
  const getData = async () => {
    setLoader(true);
    let { status, data } = await apiGet(apiPath.seriesList, {
      gameType: "all",
      type: activeTab == "tomorrow" ? "active" : activeTab,
      userId: !isEmpty(localStorage.getItem("token"))
        ? jwt_decode(localStorage.getItem("token"))?.user?._id
        : "",
    });

    if (data?.success) {
      let newResult = data?.data
        ?.map((res) => {
          return res?.matchList?.map((item) => {
            return { ...item, seriesName: res?.seriesName };
          });
        })
        .flat();
      setNewResult(
        newResult?.filter((res) => {
          return res?.hasMatchOdds;
        })
      );

      let updated = newResult.sort(
        (a, b) => new Date(a.eventDateTime) - new Date(b.eventDateTime)
      );
      setData({
        cricket: updated?.filter((res) => {
          return res?.gameType == "cricket";
        }),
        soccer: updated?.filter((res) => {
          return res?.gameType == "soccer";
        }),
        tennis: updated?.filter((res) => {
          return res?.gameType == "tennis";
        }),
      });
    }
    setLoader(false);
  };
  const getOdds = async (id) => {
    const { status, data: response_users } = await apiGet(
      apiPath.getMatchOdds +
        `?marketId=${id
          ?.map((res) => {
            return res?.marketId;
          })
          ?.join(",")}&multi=true&eventIds=${id
          ?.map((res) => {
            return res?.eventId;
          })
          ?.join(",")}`
    );
    if (status === 200) {
      if (response_users.success) {
        if (response_users.results?.length > 0) {
          setAllOdds(response_users.results);
        }
      }
    }
  };
  const fetchOdds = useCallback(async () => {
    if (newResult?.length > 0 && activeTab == "in_play") {
      await getOdds(newResult);
    }
  }, [newResult, activeTab]);
  usePolling(fetchOdds, 5000, newResult?.length > 0 && activeTab == "in_play");
  useEffect(() => {
    getData();
  }, []);
  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return; // skip initial run if needed
    }

    getData();
  }, [activeTab]);
  const addToFavioute = async (
    id,
    favoriteType,
    favoriteMarketId,
    eventType
  ) => {
    const { status, data: response_users } = await apiGet(
      apiPath.addToFavourite +
        `?eventId=${id}&favoriteType=${favoriteType}&favoriteMarketId=${favoriteMarketId}&eventType=${eventType}`
    );

    if (response_users?.success) {
    }
  };

  const RenderOther = ({ res, type }) => {
    return (
      <dl
        className="game-list-col"
        id="todayEvent_349570861763118000000"
        eventtype={1}
        opendatetime="2025-11-14 16:30"
        style={{ display: "flex" }}
      >
        <dt id="openTime" className="time">
          {activeTab == "today"
            ? moment(res?.eventDateTime).format("HH:MM")
            : moment(res?.eventDateTime).format("DD/MM HH:MM")}
        </dt>
        <dd id="eventDetail">
          {type}
          <img className="fromto" src="/images/transparent.gif" />
          {res?.seriesName}
          <img className="fromto" src="/images/transparent.gif" />
          <Link
            id="vsNameClick"
            to={`/match-detail-sky/${res?.eventId}/${res?.marketId}`}
          >
            <strong>{res?.eventName}</strong>
          </Link>
        </dd>
      </dl>
    );
  };
  return (
    <WebSkyLayout>
      <div id="centerColumn" className="col-center inplay">
        <ul style={{marginTop:"10px"}} id="inPlayTab" className="tab col3">
          {tabs.map((tab) => (
            <li>
              <a
                onClick={(e) => {
                  e.preventDefault(); // stop navigation
                  handleClick(tab.key);
                }}
                id="inPlay"
                href="#InPlay"
                className={activeTab === tab.key ? "select" : ""}
              >
                {tab.label}
              </a>
            </li>
          ))}
        </ul>
        {activeTab == "in_play" && (
          <div id="overWrap" className="over-wrap" style={{}}>
            <div className="game-wrap col3" id="inPlayEventType_4" style={{}}>
              <h3>
                <a id="eventType" className="to-expand">
                  Cricket
                </a>
              </h3>
              <ul className="slip-head">
                <li className="col-game" />
                <li className="col-matched">Matched</li>
                <li className="col-visit">1</li>
                <li className="col-draw" style={{}}>
                  x
                </li>
                <li className="col-home">2</li>
                <li className="col-info" />
              </ul>
              <div id="inplayGameList" className="game-list">
                {data?.cricket?.map((res) => {
                  let matchOdds =
                    allOdds?.find((item) => {
                      return item?.mi == res?.marketId;
                    }) || {};

                  return (
                    <SingleEvent
                      matchOdds={matchOdds}
                      res={res}
                      addToFavioute={addToFavioute}
                    />
                  );
                })}
              </div>
            </div>{" "}
            <div className="game-wrap col3" id="inPlayEventType_4" style={{}}>
              <h3>
                <a id="eventType" className="to-expand">
                  Soccer
                </a>
              </h3>
              <ul className="slip-head">
                <li className="col-game" />
                <li className="col-matched">Matched</li>
                <li className="col-visit">1</li>
                <li className="col-draw" style={{}}>
                  x
                </li>
                <li className="col-home">2</li>
                <li className="col-info" />
              </ul>
              <div id="inplayGameList" className="game-list">
                {data?.soccer?.map((res) => {
                  let matchOdds =
                    allOdds?.find((item) => {
                      return item?.mi == res?.marketId;
                    }) || {};

                  return (
                    <SingleEvent
                      matchOdds={matchOdds}
                      res={res}
                      addToFavioute={addToFavioute}
                    />
                  );
                })}
              </div>
            </div>{" "}
            <div className="game-wrap col3" id="inPlayEventType_4" style={{}}>
              <h3>
                <a id="eventType" className="to-expand">
                  Tennis
                </a>
              </h3>
              <ul className="slip-head">
                <li className="col-game" />
                <li className="col-matched">Matched</li>
                <li className="col-visit">1</li>
                <li className="col-draw" style={{}}>
                  x
                </li>
                <li className="col-home">2</li>
                <li className="col-info" />
              </ul>
              <div id="inplayGameList" className="game-list">
                {data?.tennis?.map((res) => {
                  let matchOdds =
                    allOdds?.find((item) => {
                      return item?.mi == res?.marketId;
                    }) || {};

                  return (
                    <SingleEvent
                      matchOdds={matchOdds}
                      res={res}
                      addToFavioute={addToFavioute}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        )}
        {activeTab != "in_play" && (
          <Fragment>
            <div id="sportFilter" className="function-wrap" style={{}}>
              <ul className="filter-list">
                <li className="filter-head">Sport Filters:</li>
                <li className="filter-content">
                  <span id="sport_4" style={{}} className="filter-first">
                    Cricket
                  </span>
                  <span id="sport_1" style={{}}>
                    Soccer
                  </span>
                  <span id="sport_2" style={{}}>
                    Tennis
                  </span>
                </li>
                <li className="filter-btn">
                  <a id="sportFilterPopup" className="btn">
                    Filter
                  </a>
                </li>
              </ul>
            </div>
            <div id="overWrap" className="over-wrap" style={{}}>
              <div id="sportListWrap" className="sport_list-wrap">
                {data?.cricket?.length == 0 &&
                data?.soccer?.length == 0 &&
                data?.tennis?.length == 0 ? (
                  <div id="noDataDiv" className="no-data">
                    <p>There are no events to be displayed.</p>
                  </div>
                ) : (
                  <Fragment>
                    {data?.cricket?.map((res) => {
                      return <RenderOther res={res} type={"Cricket"} />;
                    })}{" "}
                    {data?.soccer?.map((res) => {
                      return <RenderOther res={res} type={"Cricket"} />;
                    })}{" "}
                    {data?.tennis?.map((res) => {
                      return <RenderOther res={res} type={"Cricket"} />;
                    })}{" "}
                  </Fragment>
                )}
              </div>
              <div id="contentBox" className="content-box" />
            </div>
          </Fragment>
        )}
      </div>
    </WebSkyLayout>
  );
};

export default Inplay;
